import {
  Box,
  Button,
  Card,
  IconButton,
  Paper,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import AddAdmin from "./AddAdmin";
import Swal from "sweetalert2";
import AdminTableData from "./AdminTableData";
import { useSimulation } from "../../context/SimulationContext";
import axios from "axios";
import { Url } from "../../Api/Api";
import { getAccessToken } from "../../hooks/useLocalStorage";
import CustomizedInputBase from "./SerachBar";

const SimulationIndex = () => {
  const theme = useTheme();
  const { drawerOpen } = useOutletContext();
  const drawerWidth = 10;
  const collapsedWidth = 240;
  const token = getAccessToken();

  const [allAdminDetailsData, setAdminDetailsData] = useState([]);
  const [allAdminLoading, setAllAdminLoading] = useState(false);

  console.log(allAdminDetailsData, "allAdminDetailsData");

  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  console.log(filteredData, "filteredData");

  useEffect(() => {
    if (!searchText) {
      setFilteredData(allAdminDetailsData);
      return;
    }

    const lower = searchText.toLowerCase();

    const result = allAdminDetailsData?.filter((row) => {
      const rowValuesMatch = Object.values(row).some((value) =>
        String(value).toLowerCase().includes(lower)
      );

      // check institution name safely
      const institutionName = row?.institutions?.[0]?.institutions_name || "";
      const institutionMatch = institutionName.toLowerCase().includes(lower);

      const mobileNum = row?.mobile_number || "";
      const mobileMatch = mobileNum?.toLowerCase().includes(lower);

      const membersCount = String(row?.institutions?.[0]?.members_count) || "";
      const membersMatch = membersCount?.toLowerCase().includes(lower);

      return rowValuesMatch || institutionMatch || mobileMatch || membersMatch;
    });

    setFilteredData(result);
  }, [searchText, allAdminDetailsData]);

  const fetch_AllAdmin_Data = async () => {
    setAllAdminLoading(true);
    try {
      const response = await axios.get(Url.Get_All_Admin, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response?.data;

      if (Array.isArray(data)) {
        setAdminDetailsData(data);
      } else {
        setAdminDetailsData([]);
      }
    } catch (e) {
      console.log(e, "error");
      setAdminDetailsData([]);
    } finally {
      setAllAdminLoading(false);
    }
  };

  useEffect(() => {
    fetch_AllAdmin_Data();
  }, []);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#4CA4D6",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const [editOpen, setEditOpen] = useState(false);
  const [editName, setEditName] = useState();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Box
        component="main"
        sx={{
          // flexGrow: 1,
          p: 3,
          marginTop: 1,
          transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          marginLeft: `${drawerOpen ? drawerWidth : collapsedWidth}px`,
          ...(!drawerOpen && {
            transition: theme.transitions.create("margin", {
              easing: theme.transitions.easing.easeOut,
              duration: theme.transitions.duration.enteringScreen,
            }),
          }),
        }}
      >
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Box sx={{ mb: 1 }}>
            <Typography
              variant="h4"
              fontWeight="bold"
              gutterBottom
              sx={{
                background:
                  theme.palette.mode === "light"
                    ? "linear-gradient(to right, #00bfff, #00bfff)"
                    : "linear-gradient(to right, #00bfff, #00bfff)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                display: "inline-block",
              }}
            >
              Admin Controls
            </Typography>
            <Typography variant="body1" whiteSpace={"nowrap"} color="#002147">
              Manage admin and institution information effortlessly. Use this
              panel to track student data
            </Typography>
          </Box>
          <Box sx={{ width: "100%", textAlign: "end" }}>
            <AddAdmin
              editOpen={editOpen}
              setEditOpen={setEditOpen}
              editName={editName}
              fetch_AllAdmin_Data={fetch_AllAdmin_Data}
            />
          </Box>
        </Stack>
        <Box sx={{ py: 2 }}>
          <CustomizedInputBase
            searchText={searchText}
            setSearchText={setSearchText}
          />
        </Box>
        <Card
          sx={{
            p: 2,
          }}
        >
          <AdminTableData
            allAdminDetailsData={
              filteredData ? filteredData : allAdminDetailsData
            }
            allAdminLoading={allAdminLoading}
          />
        </Card>
      </Box>
    </Box>
  );
};

export default SimulationIndex;
